import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import TwitterIcon from '@mui/icons-material/Twitter';
import { IconButton, Tooltip, Typography } from '@mui/material';
import React, { useState } from 'react';

import jobPosting from '../../../static/illustrations/job-posting.svg';
import Button from '../../global/components/Button/Button';
import Snackbar from '../../global/components/Snackbar/Snackbar';
import SocialShareButton from '../../global/components/SocialShareButton/SocialShareButton';
import ColumnCard from '../../global/layouts/ColumnCard/ColumnCard';

export default function CompleteSlide(props: {
    onClose: () => Promise<void>;
    jobId: number;
}) {
    const [showCopyAlert, setShowCopyAlert] = useState(false);

    // Generate the public job posting URL using only the job ID
    const jobPostingUrl = `${window.location.origin}/job/${props.jobId}/qualify`;
    const shareMessage = 'Check out this amazing job opportunity!';

    const handleCopyLink = async () => {
        try {
            await navigator.clipboard.writeText(jobPostingUrl);
            setShowCopyAlert(true);
        } catch (err) {
            // Handle copy failure silently
            setShowCopyAlert(false);
        }
    };

    return (
        <ColumnCard
            closeScreen
            screenType={'job'}
            onClose={props.onClose}
            image={{ src: jobPosting, alt: 'Job posting' }}
            wide
        >
            <div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Typography variant={'h1'} color={'primary'}>
                        {'Your job posting is live!'}
                    </Typography>
                </div>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Typography
                        variant='body2'
                        style={{
                            marginTop: '0.875rem'
                        }}
                    >
                        {'Sit back, and let us bring great candidates to you.'}
                    </Typography>
                    <Typography
                        variant='body2'
                        style={{
                            marginBottom: '2rem'
                        }}
                    >
                        {
                            "You'll be notified each time an interview is scheduled"
                        }
                    </Typography>

                    <div style={{ marginBottom: '2rem' }}>
                        <Typography
                            variant='h6'
                            style={{
                                marginBottom: '1rem',
                                color: '#333'
                            }}
                        >
                            {'Share your job posting'}
                        </Typography>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.5rem',
                                flexWrap: 'wrap'
                            }}
                        >
                            <Tooltip
                                title={'Share to Twitter'}
                                placement={'top'}
                            >
                                <div>
                                    <SocialShareButton
                                        icon={TwitterIcon}
                                        baseUrl={
                                            'https://twitter.com/intent/tweet?text='
                                        }
                                        message={`${shareMessage} ${jobPostingUrl}`}
                                    />
                                </div>
                            </Tooltip>
                            <Tooltip
                                title={'Share to Facebook'}
                                placement={'top'}
                            >
                                <div>
                                    <SocialShareButton
                                        icon={FacebookIcon}
                                        baseUrl={
                                            'https://www.facebook.com/sharer/sharer.php?u='
                                        }
                                        message={jobPostingUrl}
                                    />
                                </div>
                            </Tooltip>
                            <Tooltip
                                title={'Share to LinkedIn'}
                                placement={'top'}
                            >
                                <div>
                                    <SocialShareButton
                                        icon={LinkedInIcon}
                                        baseUrl={
                                            'https://www.linkedin.com/sharing/share-offsite/?url='
                                        }
                                        message={jobPostingUrl}
                                    />
                                </div>
                            </Tooltip>
                            <Tooltip
                                title={'Copy job posting link'}
                                placement={'top'}
                            >
                                <IconButton
                                    onClick={handleCopyLink}
                                    aria-label={'copy link'}
                                    color={'primary'}
                                    style={{ marginLeft: '0.5rem' }}
                                >
                                    <ContentCopyIcon />
                                </IconButton>
                            </Tooltip>
                        </div>
                    </div>

                    <div style={{ marginRight: 'auto' }}>
                        <Button onClick={props.onClose} variant='contained'>
                            {'Go to dashboard'}
                        </Button>
                    </div>
                </div>
            </div>

            {/* Snackbar for copy confirmation */}
            <Snackbar
                open={showCopyAlert}
                message={'Link copied to clipboard!'}
                onClose={() => setShowCopyAlert(false)}
            />
        </ColumnCard>
    );
}
